import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Section from '../../components/common/Section';

const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
`;

const FeatureCard = styled.div`
  background-color: white;
  border-radius: ${props => props.theme.borderRadius.medium};
  padding: 2rem;
  box-shadow: ${props => props.theme.shadows.medium};
  transition: transform ${props => props.theme.transitions.medium};
  
  &:hover {
    transform: translateY(-10px);
  }
`;

const FeatureTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: ${props => props.theme.colors.primary};
`;

const FeatureDescription = styled.p`
  color: ${props => props.theme.colors.lightText};
  line-height: 1.6;
`;

const PIM = () => {
  const { t } = useTranslation();
  
  const features = [
    {
      title: t('products.pim.features.centralized'),
      description: '在一个集中的平台上管理所有产品数据，包括技术规格、描述、图像、价格等。'
    },
    {
      title: t('products.pim.features.workflow'),
      description: '自动化产品数据的收集、验证、丰富和发布流程，提高团队协作效率。'
    },
    {
      title: t('products.pim.features.quality'),
      description: '通过数据验证规则和完整性检查，确保产品数据的准确性和一致性。'
    },
    {
      title: t('products.pim.features.multichannel'),
      description: '轻松将产品信息分发到各种销售渠道，包括电子商务网站、移动应用、社交媒体等。'
    },
    {
      title: t('products.pim.features.localization'),
      description: '支持多语言和多区域的产品信息管理，满足全球市场需求。'
    }
  ];
  
  return (
    <>
      <Section 
        title={t('products.pim.title')} 
        subtitle={t('products.pim.subtitle')}
      >
        <p>{t('products.pim.content')}</p>
        
        <FeatureGrid>
          {features.map((feature, index) => (
            <FeatureCard key={index}>
              <FeatureTitle>{feature.title}</FeatureTitle>
              <FeatureDescription>{feature.description}</FeatureDescription>
            </FeatureCard>
          ))}
        </FeatureGrid>
      </Section>
    </>
  );
};

export default PIM;